import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

import { SELECTION_CONTROL_LABEL_GAP_PX } from 'theme/components/selection-control';
import type { ControlLabelSize } from 'ui/control-label/control-label.types';

interface ControlLabelRootOwnerState {
  controlSize: ControlLabelSize;
  labelGap?: number;
}

export const ControlLabelRoot = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'controlSize' && prop !== 'labelGap',
})<ControlLabelRootOwnerState>(({ controlSize, labelGap }) => ({
  gap: labelGap ?? SELECTION_CONTROL_LABEL_GAP_PX[controlSize],
}));
